import { gql } from "@apollo/client";

export const ForgotPasswordMutation = gql`
  mutation ForgotPassword(
    $username: String!
    $email: String!
    $region: AWSRegions!
    $siteUrl: String!
  ) {
    forgotPassword(
      username: $username
      email: $email
      region: $region
      siteUrl: $siteUrl
    ) {
      message
    }
  }
`;
